import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const HRControlLocalAct = lazy(() => import('./components/HRControlLocalAct'));
const LocalNormativeActs = lazy(() => import('./LocalNormativeActs'));
const LocalActsAssignments = lazy(() => import('./components/LocalActsAssignments'));
const LocalNormativeActsMonitoring = lazy(() => import('./LocalNormativeActsMonitoring'));
const ViewLocalAct = lazy(() => import('./components/ViewLocalAct'));
const LocalManagement = lazy(() => import('./components/LocalNormativeActsManagement'));

const LocalNormativeActsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: 'apps/local-normative-acts',
      element: <LocalNormativeActs />,
    },
    {
      path: 'apps/local-normative-acts/view/:id',
      element: <ViewLocalAct />,
    },
    {
      path: 'apps/local-normative-acts/assignments',
      element: <LocalActsAssignments />,
    },
    {
      path: 'apps/local-normative-acts/monitoring/:id',
      element: <LocalNormativeActsMonitoring />,
    },
    {
      path: 'apps/local-normative-acts/management',
      element: <LocalManagement />,
    },
    {
      path: 'apps/local-acts-control/:id',
      element: <HRControlLocalAct />,
    },
  ],
};

export default LocalNormativeActsConfig;
